"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { SystemFaqButton } from "@/components/SystemFaqButton";
import { useAuthStore } from "@/stores/auth";
import { logout } from "@/lib/auth";

const NAV_ITEMS = [
  { href: "/", label: "Dashboard" },
  { href: "/clients", label: "Klienci" },
  { href: "/buildings", label: "Budynki" },
  { href: "/inspections", label: "Przeglądy" },
  { href: "/legacy/import", label: "Import archiwum" },
  { href: "/legacy/inspections", label: "Archiwum" },
  { href: "/legacy/few-shot", label: "Wzorce AI" },
];

export function Navbar() {
  const router = useRouter();
  const pathname = usePathname();
  const user = useAuthStore((s) => s.user);

  async function handleLogout() {
    await logout();
    router.push("/login");
  }

  function isActive(href: string): boolean {
    if (href === "/") return pathname === "/";
    return pathname === href || pathname.startsWith(href + "/");
  }

  return (
    <nav className="sticky top-0 z-30 border-b border-slate-200 bg-white/94 px-4 py-3 shadow-sm backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3">
        <Link href="/" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded bg-blue-700 text-sm font-bold text-white">
            AI
          </span>
          <span>
            <span className="block text-base font-bold leading-tight text-slate-950">Przeglądy AI</span>
            <span className="block text-xs text-slate-500">Panel inspekcji technicznych</span>
          </span>
        </Link>
        <div className="flex flex-wrap items-center gap-1" data-testid="navbar-links">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href === "/" ? "dashboard" : item.href.slice(1)}`}
              className={
                isActive(item.href)
                  ? "rounded bg-blue-700 px-3 py-1.5 text-sm font-semibold text-white shadow-sm"
                  : "rounded px-3 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-100 hover:text-slate-950"
              }
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-3">
        <SystemFaqButton />
        <span data-testid="navbar-user" className="hidden text-sm font-medium text-slate-600 sm:inline">
          {user?.name}
        </span>
        <button
          type="button"
          onClick={handleLogout}
          data-testid="navbar-logout"
          className="btn-secondary"
        >
          Wyloguj
        </button>
        </div>
      </div>
    </nav>
  );
}
